export const isAutomationBranchApproval = (approval) => approval?.kind === 'automation_continuation'
  && approval.source_kind === 'automation'
  && Boolean(approval.scope?.sandbox_id && approval.scope?.overlay_id && approval.scope?.overlay_hash);

export const isBranchReviewApproval = (approval) =>
  ['sandbox_publication', 'ontology_schema_publication'].includes(approval?.kind)
  || isAutomationBranchApproval(approval);
